import type { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL } from '@sorare/core/src/atoms/typography';
import { NewSeasonLogo } from '@sorare/core/src/components/Season2027/NewSeasonLogo';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import {
  laptopAndAbove,
  mediumMobileHeightAndBelow,
} from '@sorare/core/src/style/mediaQuery';
import { css } from '@sorare/css';

import { MarketTabs } from '#src/components/new-season/MarketTabs/index.tsx';

import backgroundDesktop from './assets/background-desktop.webp';
import backgroundMobile from './assets/background-mobile.webp';

const Wrapper = styled.div`
  position: relative;
  isolation: isolate;
`;

const ShortViewportHidden = styled.div`
  @media ${mediumMobileHeightAndBelow} {
    display: none;
  }
`;

const Background = styled(ShortViewportHidden)`
  position: absolute;
  inset: 0 calc(-8 * var(--unit));
  background-image: url(${backgroundMobile});
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  z-index: -1;

  @container ${laptopAndAbove} {
    background-image: url(${backgroundDesktop});
    inset: 0 0 -120px 0;
  }
`;

const Content = styled.div`
  padding: calc(8 * var(--unit)) var(--container-padding) var(--double-unit);

  @media ${mediumMobileHeightAndBelow} {
    padding: 0;
  }
`;

const spacedTabs = css`
  margin-top: var(--double-unit);
`;

const MarketTabsWrapper = styled.div`
  position: absolute;
  top: var(--double-unit);
  left: 0;
`;

export const Header = ({ children }: PropsWithChildren) => {
  const isLaptopAndAbove = useIsLaptop();
  return (
    <>
      {!isLaptopAndAbove && (
        <div className={spacedTabs}>
          <MarketTabs />
        </div>
      )}
      <Wrapper>
        <Background />
        {!!isLaptopAndAbove && (
          <MarketTabsWrapper>
            <MarketTabs />
          </MarketTabsWrapper>
        )}
        <Content>
          <Vertical gap={3} center className="text-center">
            <ShortViewportHidden>
              <NewSeasonLogo size="regular" />
            </ShortViewportHidden>
            {!!isLaptopAndAbove && (
              <BrandL>
                <FormattedMessage defaultMessage="Draft The impossible" />
              </BrandL>
            )}
            {children}
          </Vertical>
        </Content>
      </Wrapper>
    </>
  );
};
